import React from 'react';
import { cn } from '../../lib/utils';
import { icons } from './Icons';

interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
  className?: string;
}

export function Breadcrumb({
  items,
  separator = <icons.ChevronRight className="h-4 w-4" aria-hidden="true" />,
  className,
}: BreadcrumbProps) {
  return (
    <nav className={cn('flex min-w-0 items-center text-sm text-neutral-600 dark:text-neutral-400', className)} aria-label="Breadcrumb">
      <ol className="flex min-w-0 flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isCurrent = item.current ?? index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex min-w-0 items-center gap-1.5">
              {index > 0 && (
                <span className="flex flex-shrink-0 items-center text-neutral-300 dark:text-neutral-600" aria-hidden="true">
                  {separator}
                </span>
              )}
              {isCurrent ? (
                <span className="truncate font-medium text-neutral-900 dark:text-neutral-100" aria-current="page">
                  {item.label}
                </span>
              ) : item.href ? (
                <a
                  href={item.href}
                  className="truncate rounded-sm transition-colors hover:text-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:hover:text-primary-300 dark:focus-visible:ring-offset-neutral-900"
                >
                  {item.label}
                </a>
              ) : (
                <span className="truncate">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
